import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Wrapper from "../Wrappers/Wrapper";
import TurnstileWidget from "./TurnstileWidget";
import {FormContainer, StyledCheckbox, StyledRadio} from "./FormStyles";

const FestiveDinner = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl = data.site.siteMetadata.siteUrl;

  return (
    <FormContainer>
      <Wrapper style={{ marginBottom: 50 }}>
        <form action={process.env.GATSBY_GOEASTFORM_FORM_ACTION} method="POST">
          <input type="hidden" name="subject" value="Festessen" />
          <input type="hidden" name="recipient" value={process.env.GATSBY_GOEASTFORM_RECIPIENT_CHRISTMAS_PARTY || ''} />
          <input type="hidden" name="redirect" value={`${siteUrl}/form-sent`} />
          <input type="hidden" name="missing" value={`${siteUrl}/form-missing`} />
          <input type="hidden" name="required" value="Bewohner" />

          <div className="form-group">
            <div className="form-input">
              <label htmlFor="bewohnende">Name und Vorname Bewohner/in *</label>
              <input type="text" id="bewohnende" name="Bewohner" required />
            </div>
          </div>

          <div className="form-group">
            <div style={{ marginBottom: 15 }}>Pflegewohnabteilung</div>
              <label><StyledRadio type="radio" name="Datum" value="Samstag, 14. November 2026, Pflegewohnabteilung 1" /> Samstag, 14. November 2026, Pflegewohnabteilung 1</label><br />
              <label><StyledRadio type="radio" name="Datum" value="Samstag, 14. November 2026, Pflegewohnabteilung 2" /> Samstag, 14. November 2026, Pflegewohnabteilung 2</label><br />

              <label><StyledRadio type="radio" name="Datum" value="Sonntag, 15. November 2026, Pflegewohnabteilung 3" /> Sonntag, 15. November 2026, Pflegewohnabteilung 3</label><br />
              <label><StyledRadio type="radio" name="Datum" value="Sonntag, 15. November 2026, Pflegewohnabteilung 4" /> Sonntag, 15. November 2026, Pflegewohnabteilung 4</label><br />
            </div>

            <div className="form-input">
              <label htmlFor="gast1">Name und Vorname Gast 1:</label>
              <input type="text" id="gast1" name="Gast_1" />
            </div>

            <div className="form-group" style={{ marginTop: 25 }}>
              <div style={{ marginBottom: 15 }}>Menu-Wahl Gast 1</div>
              <label>
                <StyledRadio type="radio" name="Gast_1_Menu-Wahl" value="Fleisch-Menu" />
                Fleisch-Menu
              </label> <br />
              <label>
                <StyledRadio type="radio" name="Gast_1_Menu-Wahl" value="Vegi-Menu" />
                Vegi-Menu
              </label>
            </div>

          <div className="form-group">
            <div style={{ marginBottom: 15 }}>Allergien Gast 1</div>
            <label><StyledCheckbox type="checkbox" name="Allergie_Zoeliakie" value="Ja"/> Zöliakie
              (glutenfrei)</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Laktose" value="Ja"/> Lactose-Intoleranz</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Nuss" value="Ja"/> Nuss-Allergie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Sellerie" value="Ja"/> Sellerie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Sulfide" value="Ja"/> Sulfide</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Soja" value="Ja"/> Soja</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Eier" value="Ja"/> Eier</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Fisch" value="Ja"/> Fisch +
              Fischerzeugnisse</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Senf" value="Ja"/> Senf</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_1_Allergie_Sesam" value="Ja"/> Sesam</label>
          </div>

          <div className="form-input">
            <label htmlFor="gast2">Name und Vorname Gast 2:</label>
            <input type="text" id="gast2" name="Gast_2" />
          </div>

          <div className="form-group" style={{ marginTop: 25 }}>
              <div style={{ marginBottom: 15 }}>Menu-Wahl Gast 2</div>
              <label>
                <StyledRadio type="radio" name="Gast_2_Menu-Wahl" value="Fleisch-Menu" />
                Fleisch-Menu
              </label> <br />
              <label>
                <StyledRadio type="radio" name="Gast_2_Menu-Wahl" value="Vegi-Menu" />
                Vegi-Menu
              </label>
            </div>


          <div className="form-group">
            <div style={{ marginBottom: 15 }}>Allergien Gast 2</div>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Zoeliakie" value="Ja"/> Zöliakie
              (glutenfrei)</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Laktose" value="Ja"/> Lactose-Intoleranz</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Nuss" value="Ja"/> Nuss-Allergie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Sellerie" value="Ja"/> Sellerie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Sulfide" value="Ja"/> Sulfide</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Soja" value="Ja"/> Soja</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Eier" value="Ja"/> Eier</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Fisch" value="Ja"/> Fisch +
              Fischerzeugnisse</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Senf" value="Ja"/> Senf</label><br/>
            <label><StyledCheckbox type="checkbox" name="Gast_2_Allergie_Sesam" value="Ja"/> Sesam</label>
          </div>

          <TurnstileWidget siteKey={process.env.GATSBY_GOEASTFORM_TURNSTILE_SITE_KEY || ''}/>

          <button type="submit">Absenden</button>
        </form>
      </Wrapper>
    </FormContainer>
  );
};

export default FestiveDinner;